import React,{ useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Notice from "../../partials/content/Notice";
import { Link } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";

import { withStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import { Formik } from "formik";
import FormControl from '@material-ui/core/FormControl';
import TGrid from "../../partials/content/Grid";
import { getLocations,getUsers,getMyProfile,getTodoUser,getStatus, bulkUpdate } from "../../crud/auth.crud";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import 'date-fns';

import {
  Portlet,
  PortletBody,
} from "../../partials/content/Portlet";


const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
}));


const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    //marginLeft: theme.spacing(1),
    //marginRight: theme.spacing(1),
  },
  dense: {
    //marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
};





class BulkUpdate extends React.Component {
  state = {
    
    status:false,
    statusMessage:'',
    loading:false,
    statusColor:'alert-success',
    selDate:new Date('2014-08-18T21:11:54'),
    user:{},
    locations:[],
    summary:[],
    mStatus:[],

  }



  


constructor(props)
{
  super(props);
    this.state = {
      menu: false,
     
      status:false,
      statusMessage:'',
      alertType:'alert-success',
      locading:false,
      statusColor:'alert-success',
      user:{},
      locations:[],
      users:[],
      summary:[],
      mStatus:[]
      
    };


    
  
}
  
  
  handleChangeComplete = (color) => {
    this.setState({ background: color.hex });
  };

  locationChange = (e) =>
 {
      console.log("account chnage::::",e);

      let searchObj = {};
      if(e.target.value !="")
      {
        searchObj = {locationKey: e.target.value}
      }
      getUsers(1,100,'firstName','asc',searchObj)
      .then((response) => {
        this.setState({ users:response.data})
        //console.log("patient by id::::",data);
       });
      

 }

  componentDidMount()
  {
    
     getMyProfile().then(response => response.data)
    .then((data) => {

       getLocations(1,100,'locationName','asc',{accountKey:data[0].accountKey})
      .then((response) => {
        this.setState({ locations:response.data})
        //console.log("patient by id::::",data);
       });
      
      //this.setState({ user: data[0] })
      //console.log(this.state.users)
     });

    getUsers(1,100,'firstName','asc',{})
      .then((response) => {
        this.setState({ users:response.data})
        //console.log("patient by id::::",data);
       });

     getStatus().then(response => response.data)
    .then((data) => {
      this.setState({ mStatus: data })
      console.log("status:::",data);
     });;
     
  }

  



  render() {
     const show = (this.state.menu) ? "show" : "" ;
     const status = (this.state.status);
     const alertType = (this.state.alertType);
     const statusMessage = (this.state.statusMessage);
     const loading = this.state.loading;
     const { classes } = this.props;
     const statusColor = this.state.statusColor;

    return (
      <>

          {this.state.status && (
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage}</div>
                        </div>
                      )}

            

           <Formik
                  initialValues={{
                   
                    }}
                  validate={values => {
                    const errors = {};

                    

                    
                    if (!values.userKey) {
                      errors.userKey = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                  

                    
                   

                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting ,setFieldValue}) => {
                    this.setState({loading:true});
                   
                    //summary of status

                      getTodoUser(values.userKey).then(response => response.data)
                      .then((data) => {
                        let count = 0;
                        data.map((m)=>(
                          count = parseInt(count) + m.count
                        ))
                        this.setState({ summary: data,loading:false,totalCount:count,fromUserId:values.userKey });
                        console.log("summary:::",data);
                        //console.log(this.state.schedules);
                       })
                      .catch(() => {

                        this.setState({loading:false});
                      });


                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                   
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
                      
        	
      		<TGrid beforeCodeTitle="Basic Details" jsCode="false">
        	<div className="kt-section">
	        	<div className="kt-section__content">
           

		   			
		   			 <div className="row align-items-center">
                <div className="col-lg-6">
                 <FormControl className={classes.formControl} style={{'width':'100%'}}>
                          <InputLabel id="locationKey-label">Location</InputLabel>
                             <Select
                              labelId="locationKey-label"
                              id="locationKey"
                              margin="normal"
                              name="locationKey"
                              value={values.locationKey}
                              onChange={(e) => {handleChange(e); this.locationChange(e);}}
                              onBlur={handleBlur}
                              className="kt-width-full"
                              style={{'width':'100%'}}
                            >
                            <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                              {this.state.locations.map((loc) =>(

                              <MenuItem value={loc.locationKey}>{loc.locationName}</MenuItem>
                              
                              ))}
                            </Select>
                         </FormControl>
                  </div>
                  <div className="col-lg-6">
                 <FormControl className={classes.formControl} style={{'width':'100%'}}>
                          <InputLabel id="userKey-label">User</InputLabel>
                             <Select
                              labelId="userKey-label"
                              id="userKey"
                              margin="normal"
                              name="userKey"
                              value={values.userKey}
                              onChange={(e)=>{handleChange(e);this.setState({totalCount:null,summary:[]})}}
                              onBlur={handleBlur}
                              className="kt-width-full"
                              style={{'width':'100%'}}
                            >
                            <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                              {this.state.users.map((usr) =>(

                              <MenuItem value={usr.userId}>{usr.firstName + ' ' +  usr.lastName}</MenuItem>
                              
                              ))}
                            </Select>
                         </FormControl>
                  </div>
                  
              </div>
              

             
             
				   
			    </div>
		    </div>
        <div className="kt-section">
          <div className="kt-section__content">
              <div className="row align-items-center">
                  <div className="col-lg-6 align-items-center">
                      <button
                          disabled={this.state.loading}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loading
                              }
                            )}`}
                           
                          >
                           Search Todo's
                        </button>
                  </div>
              </div>
          </div>
        </div>
		    </TGrid>
       
       </form>
            )}
            </Formik>
        

        {this.state.totalCount !=null &&
          <div className="row">
          <div className="col-xl-12">
              <h3>{this.state.totalCount + " todo(s) found"}</h3>
              </div>
          </div>
        }
         <div className="row">
        
        <div className="col-xl-12">

          <div className="row">

           {this.state.mStatus!=null && this.state.summary !=null && this.state.summary.length>0  && this.state.mStatus.map((status) => (
            
            this.state.summary.filter(s=> s.statusKey==status.statusKey)[0].count>0 &&
            <div className="col-lg-3">
            
              <Portlet className="kt-portlet--border-bottom-brand" >
                <PortletBody fluid={true}>
                  
                    <div className="kt-widget26">
                    <div className="kt-widget26__content">
                      <span className="kt-widget26__number" style={{'color':status.statusId}}> 
                        {this.state.summary.filter(s=> s.statusKey==status.statusKey).map((sum)=>(
                          sum.count
                          ))}
                        
                      </span>
                      <span className="kt-widget26__desc" style={{'color':status.statusId}}>{status.statusName}</span>
                    </div>
                    </div>
                  
                </PortletBody>
              </Portlet>
             </div>

            
            ))}
            
                 
          </div>
        </div>
        
        
      </div>

      {this.state.totalCount !==null && this.state.totalCount &&
      <div className="row">
          <div className="col-lg-12">
              <Formik
                  initialValues={{
                    
                    }}
                  validate={values => {
                    const errors = {};

                    

                    
                    if (!values.userKey) {
                      errors.userKey = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                  

                    
                   

                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting ,setFieldValue}) => {
                    this.setState({uloading:true});
                   
                    
                      if(this.state.fromUserId !=null)
                      {

                        let fromName = '';
                        this.state.users.filter(x=>x.userId===this.state.fromUserId).map((u)=>(
                          fromName = u.firstName + ' ' + u.lastName
                        ))

                        let toName = '';
                        this.state.users.filter(x=>x.userId===values.userKey).map((u)=>(
                          toName = u.firstName + ' ' + u.lastName
                        ))

                        if (window.confirm("Are you sure you want to move the todo(s) from "+fromName+" to "+ toName +"?")) 
                        {
                          let updateObj = {
                              fromUserId: this.state.fromUserId,
                              toUserId: values.userKey
                          };

                          bulkUpdate(updateObj).then(response => response.data)
                          .then((data) => {
                                setFieldValue('locationKey',"");
                                setFieldValue('userKey',"");
                                this.setState({status:true,uloading:false,
                                statusMessage:'User bulk assigned successfully',totalCount:null,summary:[],
                                alertType:'alert-success',statusColor:'alert-success'});
                           })
                          .catch(() => {

                            this.setState({uloading:false});
                          });

                        }
                        else
                        {
                           this.setState({uloading:false});
                        }
                    }
                    
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                   
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
                      
          
          <TGrid beforeCodeTitle="Basic Details" jsCode="false">
          <div className="kt-section">
            <div className="kt-section__content">
           

            
             <div className="row align-items-center">
                <div className="col-lg-6">
                 <FormControl className={classes.formControl} style={{'width':'100%'}}>
                          <InputLabel id="locationKey-label">Location</InputLabel>
                             <Select
                              labelId="locationKey-label"
                              id="locationKey"
                              margin="normal"
                              name="locationKey"
                              value={values.locationKey}
                              onChange={(e) => {handleChange(e); this.locationChange(e);}}
                              onBlur={handleBlur}
                              className="kt-width-full"
                              style={{'width':'100%'}}
                            >
                            <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                              {this.state.locations.map((loc) =>(

                              <MenuItem value={loc.locationKey}>{loc.locationName}</MenuItem>
                              
                              ))}
                            </Select>
                         </FormControl>
                  </div>
                  <div className="col-lg-6">
                 <FormControl className={classes.formControl} style={{'width':'100%'}}>
                          <InputLabel id="userKey-label">User</InputLabel>
                             <Select
                              labelId="userKey-label"
                              id="userKey"
                              margin="normal"
                              name="userKey"
                              value={values.userKey}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className="kt-width-full"
                              style={{'width':'100%'}}
                            >
                            <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                              {this.state.users.map((usr) =>(

                              <MenuItem value={usr.userId}>{usr.firstName + ' ' +  usr.lastName}</MenuItem>
                              
                              ))}
                            </Select>
                         </FormControl>
                  </div>

              </div>
              

             
             
           
          </div>
        </div>
          <div className="kt-section">
            <div className="kt-section__content">
                <div className="row align-items-center">
                  <div className="col-lg-6">
                       <button
                          disabled={this.state.uloading}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.uloading
                              }
                            )}`}
                           
                          >
                           Change
                        </button>
                  </div>
              </div>
            </div>
        </div>
        </TGrid>
       
       </form>
            )}
            </Formik>
        
          </div>
      </div>
    }
       
      </>
    );
  }
}

export default injectIntl(withStyles(styles)(BulkUpdate));

